var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('embedded-header'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container pt-5 mt-5"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('span',[_c('i',{staticClass:"bi bi-check-circle-fill text-success mr-2"}),_vm._v("The bookmark was saved successfully.")])])])])
}]

export { render, staticRenderFns }